import axios from 'axios'

const DashboardService = {
  async getStatistics (params = {}) {
    return axios.get('prd/dashboard', { params })
  }
}

export default DashboardService
